const keyCode = {
    UP: '38',
    DOWN: '40',
    ESC: '27',
    ENTER: '13',
    TAB: '9',
};
export default keyCode;
